import axios from "axios";
import fingerprint from "../utils/fingerprint";
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const API_KEY_TELEGRAM_BOT = process.env.REACT_APP_API_KEY_TELEGRAM_BOT;

export enum API {
  contestsPath = "/contests",
  applicationPath = "/applications",
  audioTracksPath = "/audio-tracks",

  newsPath = "/news",
  getNewsPagination = "/news",

  addsSliderPath = "/banners",
  likePath = "/like/",
  settings = "/settings",
  settingHomePage = "/home",
  audioTrackPathUpdateCount = "/count/",
  artistPath = "/artists/",
  getStaticPages = "/static_pages",
  getStaticPageById = "/static_pages/public/",

  playlistPath = "/playlists",

  healthCheck = "/health",

  getPreRoll = "/settings/pre-roll",

  getSEOSettings = "/settings",
  getDefaultCovers = "/settings/covers/one",

  feedback = "/feedback",

  vote = "/public-users/create",
  confirmationByMessage = "/public-users/voice-verify",

  getSitemap = "/sitemap",
}

const $api = axios.create({
  baseURL: BASE_API_URL,
});

$api.interceptors.request.use(async (config) => {
  config.headers.set("fingerprint", await fingerprint());

  return config;
});

export default $api;
